<template>
  <div v-html="sanitizedCellProps"></div>
</template>

<script>
import DOMPurify from "dompurify";

export default {
  name: "HTMLCell.vue",
  props: {
    cellProps: String,
  },
  computed: {
    sanitizedCellProps() {
      return DOMPurify.sanitize(this.cellProps);
    }
  }
};
</script>

<style scoped>

</style>
